module.exports = __webpack_public_path__ + "img/mt5-icon2.37e04b0.png";